export default "__VITE_ASSET__BX0GitAi__"